import type { IconName } from '../brand/Icon'

/** `experimental` — раздел помечается в рельсе звёздочкой со сноской внизу. */
export interface NavSection { id: string; labelKey: string; icon: IconName; path: string; experimental?: boolean }

export const NAV_SECTIONS: NavSection[] = [
  { id: 'maps',       labelKey: 'nav.maps',       icon: 'ic-sec-maps',       path: '/maps' },
  { id: 'models',     labelKey: 'nav.models',     icon: 'ic-sec-models',     path: '/models' },
  { id: 'buoys',      labelKey: 'nav.buoys',      icon: 'ic-sec-buoys',      path: '/buoys' },
  { id: 'imagery',    labelKey: 'nav.imagery',    icon: 'ic-sec-imagery',    path: '/imagery' },
  { id: 'satellites', labelKey: 'nav.satellites', icon: 'ic-sec-satellites', path: '/satellites' },
  { id: 'rules',      labelKey: 'nav.rules',      icon: 'ic-sec-rules',      path: '/rules' },
  { id: 'navwarn',    labelKey: 'nav.navwarn',    icon: 'ic-sec-navwarn',    path: '/navwarn' },
  { id: 'quotas',     labelKey: 'nav.quotas',     icon: 'ic-sec-quotas',     path: '/quotas', experimental: true },
  { id: 'prices',     labelKey: 'nav.prices',     icon: 'ic-sec-prices',     path: '/prices', experimental: true },
  { id: 'reports',    labelKey: 'nav.reports',    icon: 'ic-sec-reports',    path: '/reports' },
  { id: 'settings',   labelKey: 'nav.settings',   icon: 'ic-sec-settings',   path: '/settings' },
]

/** Раздел → признак кабинета, без которого его в рельсе нет. Признак считает
 *  сервер (`services` в `/cabinet/orgs`); это не гейт — гейт на ручках. */
const GATED: Record<string, string> = { prices: 'prices', reports: 'reports' }

export function visibleSections(services: Record<string, boolean> | undefined): NavSection[] {
  return NAV_SECTIONS.filter(s => !(s.id in GATED) || services?.[GATED[s.id]] === true)
}

export function findActiveSection(pathname: string): NavSection | undefined {
  return NAV_SECTIONS.find(s => pathname === s.path || pathname.startsWith(s.path + '/'))
}

// Подразделы «Настройки» — раскрываются как под-навигация в рельсе (гармошка).
export interface SettingsTab { id: string; labelKey: string; path: string }

export const SETTINGS_TABS: SettingsTab[] = [
  { id: 'profile', labelKey: 'nav.settings.profile', path: '/settings/profile' },
  { id: 'map', labelKey: 'nav.settings.map', path: '/settings/map' },
  { id: 'org', labelKey: 'nav.settings.org', path: '/settings/org' },
  { id: 'views', labelKey: 'nav.settings.views', path: '/settings/views' },
]

export function activeSettingsTab(pathname: string): SettingsTab['id'] {
  const seg = pathname.replace(/^\/settings\/?/, '').split('/')[0]
  return SETTINGS_TABS.some(t => t.id === seg) ? seg : 'profile'
}
